import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import Box from "@mui/material/Box";
import React from 'react';
import { timelineWrapperStyle, timelineDotStyle, timelineDotWarningStyle, timeLineSeparatorStyle } from './TimeLine.style';
export const TimeLine = ({ items, dataQa, separatorStyle, position = 'right' }) => {
    const isFirstOrLastItem = (item) => {
        return (Array.isArray(items) && (items.indexOf(item) === 0 || (items.indexOf(item) + 1) === items.length));
    };
    const isLastItem = (item) => {
        return (Array.isArray(items) && (items.indexOf(item) + 1) === items.length);
    };
    return (React.createElement(Box, null,
        React.createElement(Timeline, { "data-qa": dataQa, sx: position !== 'alternate' ? timelineWrapperStyle : null, position: position }, Array.isArray(items) &&
            items.map((item, index) => (React.createElement(TimelineItem, { key: `${dataQa}-item-${index}`, "data-qa": `${dataQa}-item-${index}` },
                React.createElement(TimelineSeparator, { sx: separatorStyle ? separatorStyle : timeLineSeparatorStyle },
                    React.createElement(TimelineDot, { "data-qa": `${dataQa}-item-dot-${index}`, sx: item.dotColor
                            ? timelineDotWarningStyle(item.dotColor)
                            : timelineDotStyle, color: isFirstOrLastItem(item)
                            ? "secondary"
                            : "grey" }),
                    !isLastItem(item) &&
                        React.createElement(TimelineConnector, null)),
                React.createElement(TimelineContent, null, item.children)))))));
};
